import { useT } from "../lib/i18n.tsx";
import { useState } from "react";
import { api } from "../lib/api.ts";
import { useAction } from "../lib/hooks.ts";
import { Button, Card, ErrorNotice, Field, Input } from "../components/ui.tsx";
import { SelettoreTema } from "../components/Tema.tsx";

export function LoginPage({ onAccesso }: { onAccesso: () => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const t = useT();

  const { run, running, error } = useAction(async () => {
    await api.post("/auth/login", { username, password });
    onAccesso();
  });

  return (
    <div className="mx-auto flex min-h-screen max-w-sm items-center px-5">
      {/* Anche prima di entrare si sceglie come guardare lo schermo. */}
      <div className="fixed top-4 right-5">
        <SelettoreTema />
      </div>

      <Card className="w-full p-7">
        <h1 className="text-lg font-semibold">{t.t("accesso.titolo")}</h1>

        <form
          className="mt-5 space-y-4"
          onSubmit={(event) => {
            event.preventDefault();
            void run();
          }}
        >
          <Field label={t.t("accesso.utente")}>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </Field>

          <Field label={t.t("accesso.password")}>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>

          <ErrorNotice error={error} />

          <Button type="submit" variant="primary" className="w-full" loading={running}>
            {t.t("accesso.entra")}
          </Button>
        </form>
      </Card>
    </div>
  );
}
